/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_List_EmptyInputs */

const en_us2_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workout in progress.`)
};

const pt_br2_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino em andamento.`)
};

const es_419_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún entrenamiento en curso.`)
};

const pt_pt2_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino a decorrer.`)
};

const fr_fr2_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance en cours.`)
};

const de_de2_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Training läuft.`)
};

const it_it2_workout_list_empty = /** @type {(inputs: Workout_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun allenamento in corso.`)
};

/**
* | output |
* | --- |
* | "No workout in progress." |
*
* @param {Workout_List_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_list_empty = /** @type {((inputs?: Workout_List_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_List_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_list_empty(inputs)
	if (locale === "es-419") return es_419_workout_list_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_list_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_list_empty(inputs)
	if (locale === "de-DE") return de_de2_workout_list_empty(inputs)
	if (locale === "it-IT") return it_it2_workout_list_empty(inputs)
	return en_us2_workout_list_empty(inputs)
});
export { workout_list_empty as "workout.list_empty" }